import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { Router } from '@angular/router';

import { createErrorHandler, SentryErrorHandler, TraceService } from '@sentry/angular';

export const sentryProviders: ReadonlyArray<Provider | EnvironmentProviders> = [
  {
    provide: SentryErrorHandler,
    useValue: createErrorHandler()
  },
  {
    provide: TraceService,
    deps: [Router]
  },
  provideAppInitializer(() => {
    inject(TraceService);
  })
];
